import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentPreviewContMain from "presentation/view/container/DocumentPreview/DocumentPreviewContMain";

CommonEntrypoint(<DocumentPreviewContMain/>)